export const fallbackLanguage = 'en-US';

export const supportedLocales = ['en-US', 'it-IT'] as const;

export type SupportedLocale = (typeof supportedLocales)[number];

export const defaultNamespace = 'entity-portal';

export const namespaces = [defaultNamespace] as const;
